<ng-container>
  <app-dc-alert-inner></app-dc-alert-inner>

  <div class="row h-100">
    <div class="panel col-2">
      <ul class="list-group list-group-flush types">
        <ng-container *ngFor="let type of reportsTypes">
          <li class="list-group-item bg-transparent p-0 d">
            <button
              class="tab-nav-{{ type.id }} btn text-left pl-2 rounded w-100"
              type="button"
              [class.active]="type.id === selectedReportType.id"
              (click)="selectReportType(type)"
            >
              {{ type.displayValue }}
            </button>
          </li>
        </ng-container>
      </ul>
    </div>
    <div class="col-1 v-divider"></div>
    <div class="col-9">
      <ng-container *ngIf="loading">
        <app-dc-pane
          [noScroll]="true"
          [loading]="loading"
          [noHeader]="true"
        ></app-dc-pane>
      </ng-container>
      <ng-container *ngIf="!loading">
          <app-priips-tables 
            class="tablesView"
            [source]="source" 
            [data]="data"
            [productCaptureDetail]="productCaptureDetail"
            [productType]="productType"
            [productId]="productId"
            [fvcAsOfDefault]="fvcAsOfDefault"
            [tenor]="tenor"
            (loadData)="fetchAnalytics()"
            [active]="selectedReportType.id === 'PRIIPS'">
          </app-priips-tables>
          <app-stress-testing-tables
            class="tablesView"
            [source]="source" 
            [data]="data" 
            [productType]="productType"
            [productId]="productId"
            [fvcAsOfDefault]="fvcAsOfDefault"
            (loadData)="fetchAnalytics()"
            [productCaptureDetail]="productCaptureDetail"
            [tenor]="tenor"
            [active]="selectedReportType.id === 'STRESS'">
          </app-stress-testing-tables>
      </ng-container>
    </div>
  </div>
</ng-container>
